import { createReducer } from "../../../common/reduxUtil";
import { DMAT_SET_USER } from "./types";

const initialState = {
  user: null,
};

export default createReducer(initialState, {
  [DMAT_SET_USER]: (state, user) => ({ ...state, user }),
});
